import { capitalize } from "./capitalize"

//capitalize('string')
export const codeFlagFinder = (countryCodesArray = [], CountryStudent='') => {
 const countryOfStudent = capitalize(CountryStudent)

 const codeFinder = countryCodesArray?.filter(country=> country.name ===countryOfStudent && country.code)

return codeFinder[0]?.code || ''

}
